import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {ToastService} from "../../../services/toast.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, Validators} from "@angular/forms";
import {PasswordConfirmationValidator} from "../../../validators/passwordConfirmationValidator";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit {
  isPasswordShown: boolean = false;
  isConfirmPasswordShown: boolean = false;
  resetPasswordForm: any;
  token: any;

  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly fb = inject(FormBuilder);
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  constructor() {
    this.resetPasswordForm = this.fb.group({
        email: [{value: '', disabled: true}],
        password: ['',
          [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['',
          [Validators.required]]
      },
      {validator: PasswordConfirmationValidator.validatePasswordMatch('password', 'confirmPassword')});
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];
    this.authService.introspect_forgot_password_token(this.token).then((res: any) => {
      this.resetPasswordForm.get('email').setValue(res.data.work_email);
    });
  }

  resetPassword() {
    this.resetPasswordForm.markAllAsTouched();
    if (this.resetPasswordForm.invalid) {
      if (this.resetPasswordForm.controls['confirmPassword'].errors['mustMatch']) {
        this.toastService.showToast('Passwords do not match.', 'error');
      } else {
        this.toastService.showToast('Please fill out all required fields.', 'error');
      }
      return;
    }

    const formValues = this.resetPasswordForm.getRawValue();
    const body = {
      email: formValues.email,
      resetPasswordToken: this.token,
      password: formValues.password,
      confirmPassword: formValues.confirmPassword
    };
    this.authService.resetPassword(body).then((res: any) => {
      if (res.isSuccess) {
        this.toastService.showToast('Password successfully changed', 'success');
      }
      if (res.error) {
        this.toastService.showToast(res.error.error, 'error');
      }
      this.router.navigate(['sign-in']);
    })
  }

  isInvalidAndTouched(controlName: string): boolean {
    const control = this.resetPasswordForm.get(controlName);
    return control != null && control.invalid && (control.dirty || control.touched);
  }

  toggleShowPassword() {
    this.isPasswordShown = !this.isPasswordShown;
  }

  toggleShowConfirmPassword() {
    this.isConfirmPasswordShown = !this.isConfirmPasswordShown;
  }
}
